module.exports = __webpack_public_path__ + "band_9.668d29c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_9.png
// module id = rDEc
// module chunks = 0